import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ProductImagesComponent } from './product-images/product-images.component';
import { Variant } from '../../../pages/product/product-page/product.types';
import { CustomCarouselComponent } from '../../carousel/custom-carousel/custom-carousel.component';
import { CarouselItemComponent } from '../../carousel/custom-carousel/carousel-item/carousel-item.component';

@Component({
  selector: 'app-product-media',
  imports: [
    ProductImagesComponent,
    NgOptimizedImage,
    CustomCarouselComponent,
    CarouselItemComponent,
  ],
  templateUrl: './product-media.component.html',
  styleUrls: ['./product-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductMediaComponent {
  @Input({ required: true })
  product!: Variant;
}
